import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { history } from '../store'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { renderInputLoginField } from '../utils/forms'
import { validateLoginForm } from '../utils/validation'

class LoginForm extends React.Component {
  constructor(props) {
    super(props)
  }

  goTo(e) {
    const { isAdmin } = this.props;
    const targetPath = isAdmin ? '/passwordrecovery' : '/passwordrecoveryclient';
    history.push(targetPath);
  }

  handleFormSubmit = (values) => {
    // Call the parent submit handler directly
    return this.props.onSubmit(values)
  }

  render() {
    const { error, handleSubmit, pristine, submitting } = this.props;

    return (
      <form onSubmit={handleSubmit(this.handleFormSubmit)} className='login-form'>
        <Field
          name="email"
          type="text"
          component={renderInputLoginField}
          label="Username"
        />
        <Field
          name="password"
          type="password"
          component={renderInputLoginField}
          label="Password"
        />
        <div className="text-center mb-5">
          <p className="text-white hover" onClick={e => this.goTo(e)}>¿Has olvidado tu contraseña?</p>
        </div>

        <button
          type="submit"
          disabled={pristine || submitting}
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '40px',
            backgroundColor: 'white',
            color: '#001830',
            fontWeight: 'bold',
            fontSize: '16px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
        >
          {submitting ? 'Entrando...' : 'Entrar'}
        </button>
        {error && (
          <div style={{
            backgroundColor: 'white',
            color: '#dc3545',
            padding: '10px 16px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '500',
            marginTop: '16px',
            textAlign: 'center',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            {error}
          </div>
        )}
      </form>
    );
  }
}


LoginForm = reduxForm({
  form: 'LoginForm',
  enableReinitialize: true,
  validate: validateLoginForm
})(LoginForm)

export default LoginForm

